import Highcharts from 'highcharts'
import { highchartsOptions } from './chart-options'

Highcharts.setOptions(highchartsOptions)

const element = document.getElementById('chart-payment')

if (element) {
    attach(element)
}

function create(element) {
    const jsonData = JSON.parse(element.getAttribute('data-chart-data'))
    const categories = jsonData.map((item) => item.name)

    let data = jsonData.map((item) => ({
        y: item.value,
        name: item.name,
    }))

    // Create the chart
    const chartOptions = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
            spacing: 0,
            height: 257,
        },
        title: null,
        colors: [
            '#4555FF',
            '#0DC1AE',
            '#F94D4D',
            '#FFAE41',
            '#24CB61',
            '#57BFFF',
            '#8B79FF',
            '#FF7848',
        ],
        yAxis: {
            title: {
                text: 'Total percent market share',
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                },
            },
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        accessibility: {
            point: {
                valueSuffix: '%',
            },
        },
        categories: categories,
        series: [
            {
                name: 'Podíl',
                data: data,
                dataLabels: {
                    formatter: function () {
                        return this.y > 5 ? this.point.name : null
                    },
                    distance: -5,
                },
            },
        ],
    }

    Highcharts.chart(element, chartOptions)
}

$(document).on('dom:change', function (event) {
    event.target.querySelectorAll('.chart-donut').forEach(create)
})
document.querySelectorAll('.chart-donut').forEach(create)
